/* ==========================================================================
   Secret Stories PDP, CRO Variant 1, Vanilla JS interactions
   No framework. Reads config from a `data-cro-v1-config` JSON blob in the section.
   All listeners are scoped to the .cro-v1 root.
   ========================================================================== */
(function () {
  'use strict';

  // Wait for DOM ready
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {
    var root = document.querySelector('.cro-v1');
    if (!root) return;

    // -----------------------
    // Config (from Liquid → data-cro-v1-config JSON blob)
    // -----------------------
    var config = {};
    try {
      var configEl = root.querySelector('[data-cro-v1-config]');
      if (configEl) config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.warn('[cro-v1] could not parse config', e);
    }

    var TIERS = (config.tiers || []).reduce(function (acc, t) {
      acc[String(t.id)] = t;
      return acc;
    }, {});

    var fmt = function (n) {
      return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // -----------------------
    // 1) Urgency countdown
    // -----------------------
    var countdownEls = root.querySelectorAll('[data-cro-cd]');
    if (countdownEls.length) {
      var state = { d: 2, h: 14, m: 23, s: 47 };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        state.s--;
        if (state.s < 0) { state.s = 59; state.m--; }
        if (state.m < 0) { state.m = 59; state.h--; }
        if (state.h < 0) { state.h = 23; state.d--; }
        if (state.d < 0) state.d = 0;
        countdownEls.forEach(function (el) {
          var k = el.getAttribute('data-cro-cd');
          el.textContent = k === 'd' ? state.d : pad(state[k]);
        });
      }
      tick();
      setInterval(tick, 1000);
    }

    // -----------------------
    // 2) Quantity tier select (drives ATC button label + price)
    // -----------------------
    var tierBtns = root.querySelectorAll('[data-cro-tier]');
    var atcBtn = root.querySelector('[data-cro-atc]');
    var qtyInput = root.querySelector('[data-cro-qty-input]');
    var selectedTierId = config.defaultTier || (config.tiers && config.tiers[0] && String(config.tiers[0].id));

    var shoppayAmountEl = root.querySelector('[data-cro-shoppay-amount]');
    function selectTier(id) {
      selectedTierId = id;
      tierBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-tier') === id ? 'true' : 'false');
      });
      var tier = TIERS[id];
      if (tier && atcBtn) {
        atcBtn.textContent = 'ADD TO CART · ' + fmt(tier.price);
        atcBtn.setAttribute('data-cro-tier-id', id);
      }
      // Update Shop Pay 4-installment amount under main ATC (CRO #4)
      if (shoppayAmountEl && tier) {
        shoppayAmountEl.textContent = fmt(tier.price / 4);
      }
    }
    tierBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectTier(b.getAttribute('data-cro-tier')); });
    });
    if (selectedTierId) selectTier(selectedTierId);

    // -----------------------
    // 2.5) Hero image carousel: clicking a thumb swaps the main image
    // -----------------------
    var heroMain = root.querySelector('[data-cro-hero-main]');
    var heroThumbs = root.querySelectorAll('[data-cro-hero-thumb]');
    var stickyImg = document.querySelector('[data-cro-sticky-img]');
    if (heroMain && heroThumbs.length) {
      heroThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-cro-hero-thumb');
          var alt = thumb.getAttribute('data-cro-hero-alt') || '';
          if (!src) return;
          // Update active state on thumbs (works for both V1 thumb strip and V2 gallery cells)
          heroThumbs.forEach(function (t) {
            var on = (t === thumb);
            t.classList.toggle('cro-hero__thumb--active', on);
            t.classList.toggle('cro-v2-gallery-thumb--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          // Soft fade-swap on the main image
          heroMain.classList.add('is-swapping');
          setTimeout(function () {
            heroMain.src = src;
            heroMain.alt = alt;
            // Wait one frame for the new image to start loading, then fade in
            requestAnimationFrame(function () {
              heroMain.classList.remove('is-swapping');
            });
          }, 180);
          // Mirror the swap to the sticky cart's product image
          if (stickyImg) stickyImg.src = src;
        });
      });
    }

    // -----------------------
    // 2.7) Color variant selector - fetches new product via Section Rendering API (no page reload)
    // Uses same-origin Shopify section fetch, content is trusted (server-rendered Liquid).
    // -----------------------
    var colorBtns = root.querySelectorAll('[data-cro-color-handle]');
    var colorSwapping = false;
    if (colorBtns.length) {
      colorBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (colorSwapping) return;
          if (btn.classList.contains('cro-color-select__btn--active')) return;

          var handle = btn.getAttribute('data-cro-color-handle');
          var productUrl = btn.getAttribute('data-cro-color-url');
          if (!handle || !productUrl) return;

          colorSwapping = true;
          btn.style.opacity = '0.6';

          // Shopify Section Rendering API: fetch the same section rendered with the new product
          var sectionEl = document.querySelector('.section-cro-v1');
          var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : 'main';
          var fetchUrl = productUrl + '?section_id=' + sectionId;

          fetch(fetchUrl)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              // Shopify section rendering returns trusted, server-rendered HTML from same origin
              var currentSection = document.querySelector('.section-cro-v1');
              if (currentSection) {
                currentSection.outerHTML = html;
                // Update the URL without page reload
                history.pushState({ handle: handle }, '', productUrl);
                // Re-initialize JS on the new content
                init();
              }
            })
            .catch(function (err) {
              console.warn('[cro-v1] color swap failed, falling back to navigation', err);
              window.location.href = productUrl;
            })
            .finally(function () {
              colorSwapping = false;
            });
        });
      });
    }

    // Handle browser back/forward after color swap
    window.addEventListener('popstate', function () {
      window.location.reload();
    });

    // -----------------------
    // 3) Kit toggle (Standard / Value Pack) — Value Pack adds bonuses incl. 21-day app trial
    // -----------------------
    var kitBtns = root.querySelectorAll('[data-cro-kit]');
    var selectedKit = config.defaultKit || 'value';
    function selectKit(kit) {
      selectedKit = kit;
      kitBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-kit') === kit ? 'true' : 'false');
      });
      // Set data-kit on root so CSS can show/hide value-pack-only bonus images
      root.setAttribute('data-kit', kit);
    }
    kitBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectKit(b.getAttribute('data-cro-kit')); });
    });
    selectKit(selectedKit);

    // -----------------------
    // 4) Quantity stepper (non-tier, the +/- next to ATC)
    // -----------------------
    if (qtyInput) {
      var minus = root.querySelector('[data-cro-qty-minus]');
      var plus = root.querySelector('[data-cro-qty-plus]');
      function setQty(n) {
        var clamped = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
        qtyInput.value = clamped;
      }
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    }

    // -----------------------
    // 5) Delivery estimate (real day-of-week, skips weekends)
    //    If arrival lands on Saturday or Sunday, bump forward to Monday and add a day.
    // -----------------------
    var deliveryDate = root.querySelector('[data-cro-delivery-date]');
    var deliveryNote = root.querySelector('[data-cro-delivery-note]');
    if (deliveryDate) {
      var today = new Date();
      var cutoff = new Date(today); cutoff.setHours(14, 0, 0, 0);
      var beforeCutoff = today < cutoff;
      var ship = new Date(today); ship.setDate(ship.getDate() + (beforeCutoff ? 1 : 2));
      var arrive = new Date(ship); arrive.setDate(arrive.getDate() + 4);
      // Bump arrival off the weekend onto the next business day (Monday).
      // Add an extra day for each weekend day we skip so it never reads "delivered Saturday".
      var dow = arrive.getDay(); // 0 = Sunday, 6 = Saturday
      if (dow === 6) arrive.setDate(arrive.getDate() + 2); // Sat → Mon (+2 days)
      else if (dow === 0) arrive.setDate(arrive.getDate() + 1); // Sun → Mon (+1 day)
      var dateStr = arrive.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
      deliveryDate.textContent = dateStr;
      if (deliveryNote) {
        deliveryNote.textContent = beforeCutoff
          ? 'Order in the next few hours for same-day dispatch'
          : 'Ships tomorrow morning from our South Carolina warehouse';
      }
    }

    // -----------------------
    // 6) Ecosystem persona switcher
    // -----------------------
    var personaBtns = root.querySelectorAll('[data-cro-persona]');
    var personaPanes = root.querySelectorAll('[data-cro-persona-pane]');
    function selectPersona(id) {
      personaBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-persona') === id ? 'true' : 'false');
      });
      personaPanes.forEach(function (p) {
        p.style.display = p.getAttribute('data-cro-persona-pane') === id ? '' : 'none';
      });
    }
    personaBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectPersona(b.getAttribute('data-cro-persona')); });
    });
    if (personaBtns.length) selectPersona(personaBtns[0].getAttribute('data-cro-persona'));

    // Parent CTA banner - clicking it activates the homeschool persona, then scrolls.
    root.querySelectorAll('[data-cro-persona-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = el.getAttribute('data-cro-persona-trigger');
        if (target) selectPersona(target);
      });
    });

    // -----------------------
    // 7) PO Quote calculator + form - REMOVED (Vendor Pack CTA panel only)
    // The PO section now routes to the Vendor Pack PDF; no JS hooks needed there.
    // The <details> wrapper around the PO section is collapsed on mobile so users
    // see one tap-row instead of a long scroll, and force-opened on desktop.
    // -----------------------
    var poDetails = root.querySelector('[data-cro-po-details]');
    if (poDetails) {
      var poDesktopMQ = window.matchMedia('(min-width: 901px)');
      var applyPoOpenState = function (e) {
        if (e.matches) poDetails.setAttribute('open', '');
        else poDetails.removeAttribute('open');
      };
      applyPoOpenState(poDesktopMQ);
      // Listen for viewport resize so the state stays in sync
      if (poDesktopMQ.addEventListener) poDesktopMQ.addEventListener('change', applyPoOpenState);
      else if (poDesktopMQ.addListener) poDesktopMQ.addListener(applyPoOpenState);
    }

    // -----------------------
    // 7.5) Mini FAQ near ATC (CRO #7) - independent toggle per question
    // -----------------------
    root.querySelectorAll('[data-cro-mini-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        if (!answer || !answer.classList.contains('cro-mini-faq__a')) return;
        var open = !answer.hasAttribute('hidden');
        if (open) {
          answer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          answer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
        }
        var icon = btn.querySelector('.cro-mini-faq__icon');
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    // -----------------------
    // 8) FAQ accordion
    // -----------------------
    root.querySelectorAll('[data-cro-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-cro-faq-item]');
        if (!item) return;
        var open = item.getAttribute('data-open') === 'true';
        // Close all, open this
        root.querySelectorAll('[data-cro-faq-item]').forEach(function (it) { it.setAttribute('data-open', 'false'); });
        item.setAttribute('data-open', open ? 'false' : 'true');
        var icon = btn.querySelector('[data-cro-faq-icon]');
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    // -----------------------
    // 9) Sticky cart - only appears AFTER the user scrolls past the entire hero section
    //    (not just the ATC button). Cleaner UX since the hero already has its own ATC.
    // -----------------------
    var sticky = document.querySelector('.cro-v1-sticky');
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-cro-add-to-cart]');
      // Observe the hero <section> itself. Sticky shows when the hero is no longer
      // intersecting the viewport (i.e., user has scrolled past the entire first product section).
      var heroSection = root.querySelector('.cro-hero').closest('section');
      if (heroSection && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Show sticky only when the hero section is fully out of view
            sticky.setAttribute('data-show', entry.isIntersecting ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px' });
        io.observe(heroSection);
      } else {
        // Fallback: show sticky from initial load
        sticky.setAttribute('data-show', 'true');
      }
      // Sync sticky CTA copy with the currently selected tier (CRO #9)
      var stickyNameEl = sticky.querySelector('[data-cro-sticky-name]');
      var stickyOrigName = stickyNameEl ? stickyNameEl.textContent.trim() : '';
      var syncStickyPrice = function () {
        if (!stickyBtn) return;
        var tier = TIERS[selectedTierId];
        if (tier) {
          stickyBtn.textContent = 'Add To Cart · ' + fmt(tier.price);
        }
      };
      // Re-sync whenever selectTier runs
      var origSelectTier = selectTier;
      selectTier = function (id) {
        origSelectTier(id);
        syncStickyPrice();
      };
      syncStickyPrice();
    }

    // -----------------------
    // 10) Add-to-cart submission
    // Posts to Shopify /cart/add.js with the variantId × tier qty.
    // Fires window event 'cro-v1:added-to-cart' for analytics + theme to react.
    // -----------------------
    function getSelectedVariantId() {
      var tier = TIERS[selectedTierId];
      if (!tier) return config.defaultVariantId || null;
      // New shape: tier.variants = { standard: id, value: id }
      if (tier.variants && tier.variants[selectedKit]) {
        return tier.variants[selectedKit];
      }
      // Fallback for legacy shape (single variantId per tier)
      if (tier.variantId) return tier.variantId;
      return config.defaultVariantId || null;
    }
    function getCartQty() {
      var manualQty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      // Each (tier × kit) is its own dedicated Shopify variant priced at the tier total,
      // so we always add quantity = manualQty (no multiplication). The tier's "cartQty"
      // field is kept for legacy single-variant fallback only.
      var tier = TIERS[selectedTierId];
      if (tier && (!tier.variants || !tier.variants[selectedKit]) && tier.cartQty) {
        return tier.cartQty * manualQty;
      }
      return manualQty;
    }

    function addToCart(button) {
      var variantId = getSelectedVariantId();
      if (!variantId) {
        console.warn('[cro-v1] no variantId available; falling back to first variant in DOM');
      }
      var qty = getCartQty();
      var origText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      // Match Dawn's pattern: send FormData, request the drawer's sections back
      // so we can call cartDrawer.renderContents(response) - that re-renders AND opens the drawer.
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', qty);
      var renderTarget = cartDrawer || cartNotification;
      if (renderTarget && typeof renderTarget.getSectionsToRender === 'function') {
        try {
          fd.append('sections', renderTarget.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        } catch (e) {}
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd,
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            console.warn('[cro-v1] cart add failed', res.data);
            button.textContent = 'Error · try again';
            setTimeout(function () { button.textContent = origText; button.disabled = false; }, 2400);
            return;
          }
          // Fire events for analytics / Klaviyo / GTM listeners
          try {
            window.dispatchEvent(new CustomEvent('cro-v1:added-to-cart', { detail: res.data }));
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: res.data }));
            // Dawn pub/sub - if present, downstream subscribers (cart icon bubble, etc) update
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'cro-v1-pdp',
                productVariantId: variantId,
                cartData: res.data,
              });
            }
          } catch (e) {}

          var didOpenDrawer = false;
          // Preferred path: render + open the Dawn cart drawer
          if (renderTarget && typeof renderTarget.renderContents === 'function') {
            try {
              renderTarget.renderContents(res.data);
              didOpenDrawer = true;
            } catch (e) {
              console.warn('[cro-v1] renderContents failed', e);
            }
          }
          // Fallback: click an existing drawer-open trigger
          if (!didOpenDrawer) {
            var drawerOpener = document.querySelector('[data-cart-drawer-open], .cart-drawer-toggle, [aria-controls="CartDrawer"]');
            if (drawerOpener && typeof drawerOpener.click === 'function') {
              drawerOpener.click();
              didOpenDrawer = true;
            }
          }

          button.textContent = '✓ Added to cart';
          setTimeout(function () {
            button.textContent = origText;
            button.disabled = false;
            // Last resort: send the user to /cart so they don't get stuck
            if (!didOpenDrawer && config.fallbackNavigateToCart) {
              window.location.href = '/cart';
            }
          }, 1100);
        })
        .catch(function (err) {
          console.warn('[cro-v1] cart add error', err);
          button.textContent = 'Error · try again';
          setTimeout(function () { button.textContent = origText; button.disabled = false; }, 2400);
        });
    }

    root.querySelectorAll('[data-cro-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn);
      });
    });
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-cro-add-to-cart]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          addToCart(stickyBtn);
        });
      }
    }

    // -----------------------
    // 11) Intelligems / analytics ping (no-op shim for the variant)
    // -----------------------
    try {
      window.dispatchEvent(new CustomEvent('cro-v1:rendered', {
        detail: { product: config.productHandle, ts: Date.now() }
      }));
    } catch (e) {}
  });
})();
